import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { AssetVersionDto } from '@nusign/picflow-backend-types';
import { devicePixelRatio } from '../../lib/device-pixel-ratio';
import { loadImg } from '../../lib/load-img';

@Pipe({
  name: 'failedAssetVersionUrl',
  standalone: true,
})
@Injectable({
  providedIn: 'root',
})
export class FailedAssetVersionUrlPipe implements PipeTransform {
  private async getGeneric(extension: string, width: number): Promise<string> {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    canvas.width = width * 2;
    canvas.height = width * 2;
    ctx.fillStyle = '#DEE8F1';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    const image = await loadImg('/assets/icons/document-image-grey-50.svg');

    const imageWidth = devicePixelRatio() > 1 ? 64 : 32;
    const imageHeight = image.height * (imageWidth / image.width);
    ctx.drawImage(
      image,
      canvas.width / 2 - imageWidth / 2,
      canvas.height / 2 - imageHeight / 2,
      imageWidth,
      imageHeight
    );

    ctx.font = `900 ${devicePixelRatio() > 1 ? 22 : 11}px AkkuratLL`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    if (width > 200) {
      const text = extension.toUpperCase();
      const measurement = ctx.measureText(text.toUpperCase());
      const offsetX = (measurement.actualBoundingBoxRight - measurement.actualBoundingBoxLeft) / 2;
      const offsetY = (imageHeight / 2) * 1.2;

      ctx.fillStyle = '#8595a8';
      ctx.fillText(text, canvas.width / 2 + offsetX, canvas.height / 2 + offsetY);
    }

    return canvas.toDataURL('png');
  }

  async transform(version: AssetVersionDto, width: number): Promise<string> {
    const extension = (version.asset_name?.split('.').pop() || '').toLowerCase();
    return await this.getGeneric(extension, width);
  }
}
